import { CanUseWebp } from 'constants/canUseWebp';

const lazyImageAndSrcSet = {
    fullImage: '',
    srcSet: '',
};

export const getAssetImageAndSrcSet = (
    image: string,
    filetype: string,
    dimensions: (string | number)[],
    isVisible = true,
) => {
    if (!isVisible) {
        return lazyImageAndSrcSet;
    }
    const webpOrFiletype = CanUseWebp ? 'webp' : filetype;

    const fullImage = `${
        import.meta.env.BASE_URL
    }assets/${image}.${webpOrFiletype}`;
    const srcSetMap = dimensions
        .map((dimension) => {
            const isANumber = !isNaN(dimension as number);
            const sizePrefix = isANumber ? '_' : '@';
            const dimensionSuffix = isANumber ? 'w' : '';

            return `${
                import.meta.env.BASE_URL
            }assets/${image}${sizePrefix}${dimension}.${webpOrFiletype} ${dimension}${dimensionSuffix}`;
        })
        .join(', ');

    return { fullImage, srcSet: `${srcSetMap}, ${fullImage}` };
};
